import Big from 'big.js'

/**
 *
 * Correct floating point issue with multiplying values
 * @author Jordan Harrison - <jordan.harrison@1x2network.com>
 * @version 1.0.0
 */

/**
 * Times two numbers together correctly for floating point issues, wont correctly calculate a number about max safe int
 * @param a first number to calc
 * @param b second number to calc
 * @returns more accurate number then doing the maths manually
 */
export function times(a: number, b: number) {
    return new Big(a).times(b).toNumber()
}
